export const objectHasKeys = obj => {
	if (!obj) {
		return false;
	}
	return Object.keys(obj).length > 0;
};

export const createErrorAlert = ({ error, message }) => {
	let text = `${
		error?.status ? `${error.status}: ` : ' '
	}An error occurred and has been reported to our team.`;
	if (message) {
		text = message;
	}

	return {
		message: text,
		type: 'error',
		autoDismiss: true
	};
};

export const findUrlInStringAndReturnATagTemplate = string_ => {
	const urlRegex = /(https?:\/\/[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
	return string_.replaceAll(urlRegex, function (url) {
		// Additional validation
		if (!url.startsWith('http://') && !url.startsWith('https://')) {
			return url; // Return as plain text if somehow invalid
		}
		return `<a target='_blank' rel='noopener noreferrer' style="word-break: break-word" href="${url}">${url}</a>`;
	});
};

// Host suffixes allowed to receive Aloft auth headers (e.g. axiosInstance bearer token)
const ALOFT_HOST_SUFFIXES = ['aloft.ai', 'aloft.link', 'aloft.rocks'];

export const isAloftHostedUrl = url => {
	try {
		const { hostname } = new URL(url);
		return ALOFT_HOST_SUFFIXES.some(
			suffix => hostname === suffix || hostname.endsWith(`.${suffix}`)
		);
	} catch {
		return false;
	}
};
